import { LoadingAnimation } from '@outbound-ai/ursa'
import { useState } from 'react'
import { FaArrowCircleDown, FaArrowCircleUp, FaWifi } from 'react-icons/fa'
import styled from 'styled-components'
import { httpClaims } from 'utils/http'
import { apiPaths } from 'configs/apiConfigs'
import moment from 'moment-timezone'
import { Button } from '@outbound-ai/ursa'

export const SettingsDiagnosticNetwork = () => {
  const [uploadSpeed, setUploadSpeed] = useState('-- --')
  const [downloadSpeed, setDownloadSpeed] = useState('-- --')
  const [loading, setLoading] = useState(false)
  const [isTesting, setIsTesting] = useState('Test Network')
  const [time, setTime] = useState('')
  const calculateDownloadSpeed = () => {
    const startTime: any = new Date().getTime()

    httpClaims.get(apiPaths.downloadSpeedTest()).then((response) => {
      if (response) {
        const endTime = new Date().getTime()
        const duration = (endTime - startTime) / 1000
        const bitsLoaded = response.data.length * 8
        const speed = (bitsLoaded / duration / 1024 / 1024).toFixed(2)
        setDownloadSpeed(speed)
        calculateUploadSpeed(response)
      }
    })
  }

  const calculateUploadSpeed = (file: any) => {
    const startTimeUpoload: any = new Date().getTime()
    httpClaims
      .post(apiPaths.uploadSpeedTest(), file.data, {
        headers: { 'Content-Type': 'multipart/form-data', Accept: 'text/plain' },
      })
      .then((response) => {
        if (response) {
          const endTimeUpload = new Date().getTime()
          const duration = (endTimeUpload - startTimeUpoload) / 1000
          const bitsLoaded = file.data.length * 8
          const speed = (bitsLoaded / duration / 1024 / 1024).toFixed(2)
          setUploadSpeed(speed)
          const time_completed =
            moment(new Date()).local().format('MM/DD/YYYY') +
            ' at ' +
            moment(new Date()).local().format('hh:mm a') +
            ' ' +
            moment(new Date()).tz(moment.tz.guess()).zoneAbbr()
          setTime(time_completed)
          setLoading(false)
          setIsTesting('Test Network Again')
        }
      })
  }

  const GenerateSpeed = async () => {
    setLoading(true)
    calculateDownloadSpeed()
  }

  return (
    <Div>
      <div className="network-devices-options">
        <div className="network-devices-option">
          <FaWifi />
          {loading ? (
            <button>
              <LoadingAnimation /> Testing
            </button>
          ) : (
            <Button variant="info" radius="rounded" size="normal" onClick={() => GenerateSpeed()}>
              {isTesting}
            </Button>
          )}
        </div>

        <div className="network-devices-option">
          <h3>Your Network Speed</h3>
          <p>{time}</p>
          <div className="network-info">
            <div className="info">
              <h4>
                <FaArrowCircleUp /> Upload Speed
              </h4>
              <p>
                <strong>{uploadSpeed}</strong> Mbps
              </p>
            </div>
            <div className="info">
              <h4>
                <FaArrowCircleDown /> Download Speed
              </h4>
              <p>
                <strong>{downloadSpeed}</strong> Mbps
              </p>
            </div>
          </div>
        </div>
      </div>
    </Div>
  )
}

const Div = styled.div`
  .network-devices-options {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 1rem;

    > * {
      flex: 1;
      display: flex;
      align-items: stretch;
      flex-direction: column;
      gap: 1rem;
    }

    .network-devices-option {
      padding: 1rem 1rem;
      svg {
        width: 64px;
        height: 44.8px;
        flex-grow: 0;
        margin: 11px 183px 51.2px 83px;
        border: solid 0 #000;
        color: #5dbaab;
      }
      span {
        font-size: 10px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #a9abae;
        margin-top: -1rem;
      }

      button {
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 20px 100px 16px 0;
        border-radius: 8px;
        background-color: #277cc0;
        color: #ffffff;
      }

      button .dissbled {
        height: 32px;
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 20px 100px 16px 0;
        padding: 14px 28px;
        border-radius: 8px;
        background-color: #277cc0;
        opacity: 1;
        color: #ffffff;
        span {
          margin-left: 10px;
        }
      }

      h3 {
        font-family: Milliard;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #091f5a;
      }
    }
    .network-info {
      display: flex;
      flex-direction: column;
      text-align: left;
      .info {
        margin-bottom: 1rem;
        display: grid;
        grid-align-items: center;
      }

      h4 {
        font-family: Milliard;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        margin-bottom: 20px;
        margin-top: 10px;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #091f5a;
        svg {
          width: 13px;
          height: 13px;
          flex-grow: 0;
          margin: 0.4px 5.6px 2.6px 0;
          border: solid 0 #000;
          color: #77b3cb;
        }
      }
      p {
        font-family: Milliard;
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #72767a;
        strong {
          margin-right: 10px;
          font-size: 20px;
        }
      }
    }
  }
`
